import { hasSelectedFacets, getSort } from "./modules/search";

export const shouldRenderPagination = state =>
  !hasSelectedFacets(state) && !getSort(state);
